/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Share Name" |
*
* @param {Team_Share_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_name_placeholder = /** @type {((inputs?: Team_Share_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du partage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Name der Aktien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condividi Nome")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compartir nombre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("股份名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シェア名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नाम साझा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Compartilhar Nome")
	return /** @type {LocalizedString} */ ("Share Name")
});